export default __webpack_public_path__ + "static/media/Bjorn_E.0dd6182c.png";